import React from "react";
// import utils
import * as Yup from "yup";
// import component
import PageHeading from "../../components/PageHeading";
import UserForm from "../../components/Forms/UserForm";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import userServices from "../../services/users";
import { toast } from "react-hot-toast";
import { useQuery, useQueryClient } from "react-query";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";

const validationSchema = Yup.object().shape({
    name: Yup.string().required("هذا الحقل مطلوب"),
    username: Yup.string()
        .required("هذا الحقل مطلوب")
        .min(5, "على الاقل 5 محارف"),
    password: Yup.string().min(8, "على الاقل 8 محارف"),
    level: Yup.string().required("هذا الحقل مطلوب"),
    is_available: Yup.string().required("هذا الحقل مطلوب"),
});
const EditUser = ({ title }) => {
    const { id } = useParams();
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { data, isLoading, error } = useQuery(["getUser", id], () =>
        userServices.getUser(id)
    );
    const onSubmit = (values, { setSubmitting }) => {
        const data =
            values.password !== ""
                ? values
                : {
                      username: values.username,
                      name: values.name,
                      level: values.level,
                      is_available: values.is_available,
                      max_emergency_balance: values.max_emergency_balance,
                  };
        userServices
            .updateUser(data, id)
            .then(res => {
                toast.success("تم التعديل بنجاح");
                queryClient.refetchQueries("getUsers");
                setTimeout(() => {
                    navigate("/users", { replace: true });
                }, 1500);
            })
            .catch(err => {
                console.log(err);
                if (err.response.status === 422) {
                    toast.error("اسم المستخدم موجود مسبقا");
                } else {
                    toast.error("فشل تعديل المستخدم");
                }
                setTimeout(() => {
                    setSubmitting(false);
                }, 1500);
            });
    };
    if (isNaN(Number(id)) || !id || error) {
        return <Navigate to="/404" />;
    }

    return (
        <div>
            <PageHeading>{title}</PageHeading>
            {isLoading ? (
                <DCard className="min-h-[400px]">
                    <DSpinner />
                </DCard>
            ) : (
                <UserForm
                    onSubmit={onSubmit}
                    initialValues={{ ...data.data, password: "" }}
                    validationSchema={validationSchema}
                    btnText="تعديل المستخدم"
                    gridStyle="sm:grid-cols-2"
                />
            )}
        </div>
    );
};

export default EditUser;
